/**
 * Current calendar quarter + year. Quarter is 1–4 via `Math.ceil(month / 3)` (Jan–Mar = Q1,
 * … Oct–Dec = Q4). This is the single source of truth for "which quarter is it now" shared by
 * the quarter-stamped WorkDocs root folder name (utils/workDocsFolderPlan.ts) and the PDF's
 * `talentCardPeriod` label (utils/pdfGenerator.ts) — they format the value differently but must
 * never disagree on the quarter itself.
 */
export const getCurrentQuarter = (): { year: number; quarter: number } => {
  const now = new Date();
  return { year: now.getFullYear(), quarter: Math.ceil((now.getMonth() + 1) / 3) };
};
